import { createStyles } from "@material-ui/core";
export var styles = function (theme) {
    return createStyles({
        card: {
            "&.active": {
                backgroundColor: theme.palette.primary.main,
            },
            "&:hover": {
                backgroundColor: theme.palette.primary.light,
            },
            border: "1px solid #d2cfcf",
            borderRadius: 5,
            boxShadow: "none",
            boxSizing: "border-box",
            cursor: "pointer",
            height: 90,
            padding: theme.spacing(1.5, 0.5, 0, 0.5),
            position: "relative",
            width: 90,
        },
        img: {
            "&.active": {
                filter: "invert(100%)",
            },
            backgroundSize: "contain",
            display: "block",
            height: 39,
            margin: "auto",
            width: 36,
        },
        radio: {
            display: "none",
        },
        radioLabel: {
            "& span": {
                fontSize: 14,
                lineHeight: "2px",
                wordBreak: "break-word"
            },
            "&.active": {
                "& span": {
                    color: "white",
                },
                color: "white",
            },
            display: "inline-block",
            margin: "0 auto",
            textAlign: "center",
            width: "100%",
        },
    });
};
//# sourceMappingURL=radioForm.style.js.map